module.exports = "http://localhost:4567/assets/fonts/f4769f9bdb7466be65088239c12046d1.eot";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot
// module id = 318
// module chunks = 4